import React, { Component } from 'react';
import {UserSelector }from '/app/src/model/selectors'
import { connect } from 'react-redux';
export default function Authorization(allowedRoles) {
  return WrappedComponent => {
      class WithAuthorization extends Component {
          render() {
              const { role } = this.props;
              if (allowedRoles.includes(role)) {
                  return <WrappedComponent {...this.props} />;
              } else {
                  return null;
              }
          }
      };
      return connect(state => {
      return {
          role: UserSelector.getRole(state)
      };
    })(WithAuthorization);
};
};



// WEBPACK FOOTER //
// ./src/hoc/authorization.js